import { render, staticRenderFns } from "./FrecuentQuestions.vue?vue&type=template&id=7ee48480&"
import script from "./FrecuentQuestions.vue?vue&type=script&lang=js&"
export * from "./FrecuentQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports